import { Component, Input } from '@angular/core';
import { CalendarDate, CalendarDateRange, SelectedRange } from '@app/shared/models/volume-dashboard.model';
import {
  comparisonReachesBeforeData,
  formatDataSince,
  selectedRangeReachesBeforeData,
} from '@app/shared/utilities/volume-comparison';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-report-data-warning',
  templateUrl: './report-data-warning.component.html',
  styleUrl: './report-data-warning.component.scss',
  standalone: false,
})
export class ReportDataWarningComponent {
  @Input() comparisonPeriod: CalendarDateRange | null = null;
  @Input() dataSince: CalendarDate | null = null;
  @Input() selectedRange: SelectedRange | null = null;

  constructor(private translate: TranslateService) {}

  get warningKey(): string | null {
    // Current-period coverage takes precedence over comparison-only coverage.
    if (selectedRangeReachesBeforeData(this.selectedRange, this.dataSince)) {
      return 'App.Admin.Dashboard.Labels.SelectedRangeDataSinceWarning';
    }
    if (comparisonReachesBeforeData(this.comparisonPeriod, this.dataSince)) {
      return 'App.Admin.Dashboard.Labels.ComparisonDataSinceWarning';
    }
    return null;
  }

  get dataSinceLabel(): string {
    return formatDataSince(this.dataSince, this.translate.currentLang);
  }
}
